import { useTranslation } from "react-i18next";
import { APP_KIND } from "@config";

export default function DigitalTwinIllustration({
  appKind = APP_KIND,
}) {
  const { t } = useTranslation();
  const kind = appKind === "trainer" ? "trainer" : "monitoring";

  return (
    <div className="v2-digital-twin" role="img" aria-label={t("v2.login.illustration_aria")}>
      <div className="v2-twin-glow" aria-hidden="true" />
      <div className="v2-twin-network" aria-hidden="true" />
      <div className="v2-twin-orbit" aria-hidden="true" />
      <div className="v2-twin-orbit v2-twin-orbit--secondary" aria-hidden="true" />
      <img
        className="v2-twin-avatar"
        src="/digitaltwin_login_avatar.png"
        alt=""
        aria-hidden="true"
      />
      <div className="v2-twin-scan" aria-hidden="true" />
      <div className="v2-twin-metric v2-twin-metric--top">
        <span>{t("v2.login.illustration.top_label")}</span>
        <strong>{t(`v2.login.illustration.${kind}.top_value`)}</strong>
      </div>
      <div className="v2-twin-metric v2-twin-metric--upper">
        <span>{t(`v2.login.illustration.${kind}.upper_label`)}</span>
        <strong>
          {t(`v2.login.illustration.${kind}.upper_value`)}
          <small>/10</small>
        </strong>
      </div>
      <div className="v2-twin-metric v2-twin-metric--lower">
        <span>{t(`v2.login.illustration.${kind}.lower_label`)}</span>
        <strong>
          {t(`v2.login.illustration.${kind}.lower_value`)}
          <small>/10</small>
        </strong>
      </div>
      <div className="v2-twin-ground" aria-hidden="true" />
    </div>
  );
}
